import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Menu} from "primeng/menu";
import {MenuItem} from "primeng/api";
import {ModalService} from "../../../../service/modal.service";
import {MessageToastService} from "../../../../service/message-toast.service";
import {ComplaintStatus} from "../../../../shared/enums/status.enum";
import {take} from "rxjs";
import {FeedbackResponse} from "../../../../shared/model/response/feedback-response";
import {FeedbackService} from "../../../../service/api/feedback.service";

@Component({
    selector: 'app-feedback-drop-down',
    templateUrl: './feedback-drop-down.component.html',
    standalone: false
})
export class FeedbackDropDownComponent implements OnInit {

  @ViewChild('menu') menu: Menu

  @Input('feedback') feedback: FeedbackResponse

  @Input('clickEvent')
  set mouseEvent(mouseEvent: MouseEvent) {
    this.initMenu()
    this.menu?.toggle(mouseEvent)
  }

  @Output('onTerminateFeedbackSuccess') onTerminateFeedbackSuccessEmitter = new EventEmitter<FeedbackResponse>()

  items: MenuItem[] | undefined;

  showMessageModal = false

  constructor(
    private modalService: ModalService,
    private feedbackService: FeedbackService,
    private messageService: MessageToastService,
  ) {
  }

  //------------------------------

  ngOnInit(): void {

  }

  initMenu() {
    this.items = [
      {
        items: [
          {
            visible: true,
            label: 'Visualizar',
            icon: 'pi pi-eye',
            command: () => this.showMessageModal = true
          },
          {
            visible: this.feedback?.status?.code === ComplaintStatus.PENDING,
            label: 'Fechar Feedback',
            icon: 'pi pi-check',
            command: () => this.onTerminateFeedback()
          }
        ]
      }
    ];
  }

  // complaint actions
  onTerminateFeedback() {
    this.modalService.simpleConfirmation({
      message: "Tem certeza que pretende alterar o estado deste feedback/mensagem para Fechado?"
    })
      .then(confirmed => {
        if (confirmed) {
          this.apiOnTerminateFeedback()
        }
      })
  }

  //api calls
  apiOnTerminateFeedback() {
    this.feedbackService.terminateFeedback(this.feedback.id).pipe(take(1)).subscribe({
      next: value => {
        this.messageService.success(value.message)
        this.onTerminateFeedbackSuccessEmitter.emit(this.feedback)
      },
      error: err => this.messageService.error(err.message)
    })
  }

}
